module.exports = __webpack_public_path__ + "static/media/on_hover_ds.2d9a1bf3.mov";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/on_hover_ds.mov
// module id = 140
// module chunks = 0